import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { DateVector } from '../../utils/DateVector';
export var useDatePickerDaySelectorSelection = function useDatePickerDaySelectorSelection(calendar, dirtyInternalValueVector, selectionStartCandidate, selectionEndCandidate) {
  return useMemo(function () {
    var dateStart = dirtyInternalValueVector.dateStart,
        dateEnd = dirtyInternalValueVector.dateEnd;
    var selectionStartDate = dateStart;
    var selectionEndDate = dateEnd;

    if (selectionStartCandidate && selectionEndCandidate) {
      selectionStartDate = selectionStartCandidate;
      selectionEndDate = selectionEndCandidate;

      if (selectionEndDate.isSmallerThan(selectionStartDate)) {
        var cup = selectionStartDate;
        selectionStartDate = selectionEndDate;
        selectionEndDate = cup;
      }
    }

    return calendar.map(function (date) {
      var vector = DateVector.createFromStructure(date);
      var leftEnd = vector.isEqualTo(selectionStartDate);
      var rightEnd = vector.isEqualTo(selectionEndDate);
      var selected = vector.isGreaterThan(selectionStartDate) && vector.isSmallerThan(selectionEndDate);
      return _objectSpread(_objectSpread({}, date), {}, {
        itemProps: {
          'data-day': date.day,
          'data-month': date.month,
          'data-year': date.year,
          'data-displayed-month': date.displayedMonth ? '1' : '0'
        },
        buttonProps: {
          selected: selected,
          leftEnd: leftEnd,
          rightEnd: rightEnd,
          current: date.current,
          displayedMonth: date.displayedMonth
        },
        paddingProps: {
          selected: selected,
          leftEnd: leftEnd,
          rightEnd: rightEnd,
          current: date.current,
          displayedMonth: date.displayedMonth
        }
      });
    });
  }, [calendar, dirtyInternalValueVector, selectionStartCandidate, selectionEndCandidate]);
};